export const PERSON_ACTIONS = {
  OPEN_PERSON: "open-person",
  CLOSE_PERSON: "close-person",
  SET_PERSON_INFO: "set-person-info",
  UPDATE_PERSON: "update-person",
  UPDATE_PERSON_PERSONAL_ATTRIBUTE: "update-person-personal-attribute",
  MERGE_PERSON_PERSONAL_ATTRIBUTE: "merge-person-personal-attribute",
  UPDATE_PERSON_ATTRIBUTE: "update-person-attribute",
};
